module.exports = __webpack_public_path__ + "img/apple-store-badge.d47f65be.svg";